module.exports = __webpack_public_path__ + "img/huilan.e9e0c81d.png";